import React,{ Component } from 'react';

import { 
  Container, 
  Row, 
  Col,
  Card,
  FormGroup,
  Label,
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Form from '../../../shared/components/Form';
import Button from '../../../shared/components/Button';
import TextInput from '../../../shared/components/TextInput';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';

import moment from 'moment';

import find from 'lodash/find';

import { formatPaymentMethod, urlRoot } from '../../../shared/utils';

import { DABBL_PUBLISHER_ID } from '../../../config';

class ManageAccount extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      isUpdating:false,
      error:null,
      validationMessages:{}
    };
  }

  componentDidMount(){
    const {
      activeUser,
      loadPaymentMethodsForAgency,
      loadAgency,
      loadAccountHistory
    } = this.props;

    Promise
      .all([
        loadPaymentMethodsForAgency(activeUser.agencyId),
        loadAgency(activeUser.agencyId)
      ])
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  handleSubmit(data){
    this.setState({isUpdating:true});
    this.props.updateAgency(this.props.activeAgency.id,{
      name:data.name,
      websiteUrl:data.websiteUrl,
      defaultPaymentMethodId:data.defaultPaymentMethodId
    })
      .then(() => this.setState({isUpdating:false}))
  }

  renderEventCell(item){
    if(item.fromAccountId === DABBL_PUBLISHER_ID){
      return ( <span>Funds added</span> )
    } else if(item.fromAccountId === this.props.activeAgency.id){
      return (<span>Campaign launched</span>)
    }
    return (<span>Other</span>)
  }

  renderDescriptionCell(item){
    if(item.fromAccountId === DABBL_PUBLISHER_ID){
      const paymentMethod = find(this.props.allPaymentMethods, (p) => p.id === item.paymentMethodId);

      if(paymentMethod){
        return (<span>{formatPaymentMethod(paymentMethod)}</span>)
      } else {
        return (<span>{item.paymentMethodId}</span>)
      }
    } else if(item.fromAccountId === this.props.activeAgency.id){
      return (<span>{item.toName}</span>)
    }

    return (<span></span>)
  }

  renderAmountCell(item){
    if(item.fromAccountId === this.props.activeAgency.id){
      return (<span>(<MoneyDisplay>{item.amount}</MoneyDisplay>)</span>)
    } else {
      return (<span><MoneyDisplay>{item.amount}</MoneyDisplay></span>)
    }
  }


  render(){
    const { 
      validationMessages, 
      isUpdating 
    } = this.state;

    const { 
      activeAgency, 
      activePaymentMethods, 
      allPaymentMethods,
      allCampaigns,
      deletePaymentMethod, 
      match, 
      agencyAccountingBalance,
      transfers 
    } = this.props;

    return (
      <div className='ManageAccount'>
        <Container>
          <Row className='EntityList-title'>
            <Col xs='6'>
              <h1>Manage Account</h1>
            </Col>
            <Col xs='6'></Col>
          </Row>
          <Row>
            <Col xs='12'>
              <Form onSubmit={(data) => this.handleSubmit(data)}>
                <Row>
                  <Col xs='6'>
                    <TextInput 
                      name='name' 
                      label='Name' 
                      defaultValue={activeAgency.name}
                      placeholder='Acme INC'
                      warning={validationMessages['name']}
                    />
                  </Col>
                  <Col xs='6'>
                    <TextInput 
                      name='websiteUrl' 
                      label='Website URL'
                      defaultValue={activeAgency.websiteUrl}
                      placeholder='www.acmeinc.com'
                      warning={validationMessages['websiteUrl']}
                    />
                  </Col>
                </Row>
                <br />
                <FormGroup>
                  <Label>Payment Methods</Label>
                  <SearchableDataTable 
                    items={activePaymentMethods}
                    emptyText='No payment methods available'
                    hideSearch
                    columns={[
                      {
                        name:'name',
                        width:60,
                        renderCell:(item) => (<span>{formatPaymentMethod(item)}</span>)
                      },
                      {
                        name:'default',
                        width:20,
                        renderCell:(item) => (
                          <input 
                            type='radio'
                            name='defaultPaymentMethodId'
                            value={item.id} 
                            defaultChecked={item.id === activeAgency.defaultPaymentMethodId}
                          />
                        )
                      },
                      {
                        width:20,
                        renderCell:(item) => (
                          <div className='pull-right'>
                            <Button
                              size='sm'
                              textColor='#666666'
                              borderColor='#cccccc'
                              backgroundColor='#fff'
                              confirmationText={`Removing this payment method will not affect existing approved experiences`}
                              confirmationAcceptText='Confirm'
                              confirmationRejectText='Cancel'
                              onClick={() => deletePaymentMethod(activeAgency.id,item.id)}
                            >
                              Delete
                            </Button>
                          </div>
                        )
                      }
                    ]}
                  />
                  <Link to={`${urlRoot(match.url)}/payment/new`}>New Payment Method</Link>
                </FormGroup>
                <br />
                <Button isSubmit>{isUpdating ? 'Updating...':'Update'}</Button>
                <br />
                <br />
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

ManageAccount.propTypes = {
  //TODO: Fill in prop types for ManageAccount
};

ManageAccount.defaultProps = {
  //TODO: Fill in defaultProps for ManageAccount
};

export default ManageAccount;



// WEBPACK FOOTER //
// ./src/routes/ManageAccount/components/ManageAccount.js